var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexinvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3346 14.1133V12.5C22.3346 11.8598 22.0732 11.2762 21.6515 10.8482C21.2324 10.4296 20.6493 10.1725 20.0116 10.1666L22.3346 14.1133ZM22.3346 14.1133C22.3346 14.5686 22.192 14.9079 21.9673 15.1326M22.3346 14.1133L21.9673 15.1326M21.9673 15.1326C21.7425 15.3573 21.4033 15.5 20.948 15.5M21.9673 15.1326L20.948 15.5M20.948 15.5H19.0013M20.948 15.5H19.0013M19.0013 15.5V11.1733C19.0013 10.6168 19.4586 10.1617 20.0116 10.1666L19.0013 15.5Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.1974 22.7677L10.1989 22.7665L11.3387 21.9134L10.1974 22.7677ZM10.1974 22.7677C9.97887 22.9332 9.66536 22.7804 9.66536 22.5V13.1667V12.5C9.66536 11.8069 9.82299 11.2312 10.1676 10.8321C10.5044 10.4421 11.0669 10.1667 11.9987 10.1667H12.6654H18.6671M10.1974 22.7677L18.6671 10.1667M18.6671 10.1667C18.4569 10.4456 18.332 10.7922 18.332 11.1667V22.5C18.332 22.7702 18.0198 22.9303 17.7978 22.766C17.7977 22.7659 17.7975 22.7658 17.7974 22.7657L16.66 21.9144C16.2651 21.6121 15.7054 21.6553 15.3563 22.0043L14.2363 23.1243C14.1066 23.2541 13.8911 23.2542 13.7613 23.1245C13.7612 23.1245 13.7611 23.1244 13.7611 23.1243L12.6551 22.0117L12.6544 22.011C12.2986 21.6552 11.7399 21.6127 11.3389 21.9132L18.6671 10.1667Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.0067H16C16.0892 17.0067 16.1667 17.0841 16.1667 17.1733C16.1667 17.2626 16.0892 17.34 16 17.34H14C13.9108 17.34 13.8333 17.2626 13.8333 17.1733C13.8333 17.0841 13.9108 17.0067 14 17.0067Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6733H14C13.9108 14.6733 13.8333 14.5958 13.8333 14.5066C13.8333 14.4174 13.9108 14.3399 14 14.3399H16C16.0892 14.3399 16.1667 14.4174 16.1667 14.5066C16.1667 14.5958 16.0892 14.6733 16 14.6733Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 13.84C11.6058 13.84 11.3125 14.14 11.3125 14.5066C11.3125 14.8733 11.6125 15.1733 11.9792 15.1733C12.3458 15.1733 12.6458 14.8733 12.6458 14.5066C12.6458 14.14 12.3458 13.84 11.9792 13.84Z",
    fill: "#6F00FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 16.5066C11.6058 16.5066 11.3125 16.8066 11.3125 17.1733C11.3125 17.5399 11.6125 17.8399 11.9792 17.8399C12.3458 17.8399 12.6458 17.5399 12.6458 17.1733C12.6458 16.8066 12.3458 16.5066 11.9792 16.5066Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexinvoice);
export default __webpack_public_path__ + "static/media/flexinvoice.ceed3d746c48fec95d02b025747f33c8.svg";
export { ForwardRef as ReactComponent };